// client/src/components/VersionFooter.jsx
// Small version chip used everywhere. Matches the convention from XPO so
// operators can quickly tell what's deployed without digging into
// /api/version. Fetched once, cached forever (the version is fixed per
// deploy — a redeploy reloads the page anyway).

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export default function VersionFooter({ className = '' }) {
  const { data } = useQuery({
    queryKey: ['version'],
    queryFn: () => api.get('/api/version'),
    staleTime: Infinity,
    retry: false,
  });
  return (
    <div className={`text-center py-4 ${className}`}>
      <span
        className="inline-flex items-center gap-1.5 rounded-full
                   bg-white/70 border border-ink-200/70 px-2.5 py-0.5
                   text-[11px] font-semibold text-ink-500 num"
        title="Build version"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-mint-500" />
        v{data?.version || '…'}
      </span>
    </div>
  );
}
